/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CenterCountDto } from '../../models/center-count-dto';

export interface UserCenterControllerGetCount$Params {
  centerId: string;
}

export function userCenterControllerGetCount(http: HttpClient, rootUrl: string, params: UserCenterControllerGetCount$Params, context?: HttpContext): Observable<StrictHttpResponse<CenterCountDto>> {
  const rb = new RequestBuilder(rootUrl, userCenterControllerGetCount.PATH, 'get');
  if (params) {
    rb.query('centerId', params.centerId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CenterCountDto>;
    })
  );
}

userCenterControllerGetCount.PATH = '/api/center/user/count';
